var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("h1", { staticClass: "text-center bot-blue" }, [
        _vm._v("Tạo file QRCode từ excel"),
      ]),
      _c(
        "bot-spinner",
        {
          model: {
            value: _vm.spinner,
            callback: function ($$v) {
              _vm.spinner = $$v
            },
            expression: "spinner",
          },
        },
        [
          _c("v-file-input", {
            attrs: {
              placeholder: "Upload files",
              label: "Upload files",
              accept:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "show-size": "",
            },
            on: { change: _vm.onFileChange },
            model: {
              value: _vm.values.files,
              callback: function ($$v) {
                _vm.$set(_vm.values, "files", $$v)
              },
              expression: "values.files",
            },
          }),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-col", [_vm._v("Tên file:")]),
                  _c(
                    "v-col",
                    [
                      _c("v-combobox", {
                        attrs: {
                          items: _vm.items.fileNames,
                          label: "chọn cột tên file",
                          dense: "",
                          "append-icon": "",
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.values.fileName,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "fileName", $$v)
                          },
                          expression: "values.fileName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _c("v-col", [_vm._v("Nội dung:")]),
                  _c(
                    "v-col",
                    [
                      _c("v-combobox", {
                        attrs: {
                          items: _vm.items.fileTexts,
                          label: "chọn nội dung qrcode",
                          dense: "",
                          "append-icon": "",
                          "persistent-hint": "",
                        },
                        model: {
                          value: _vm.values.fileText,
                          callback: function ($$v) {
                            _vm.$set(_vm.values, "fileText", $$v)
                          },
                          expression: "values.fileText",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary", disabled: !_vm.isValidAll },
                  on: { click: _vm.submit },
                },
                [
                  _vm._v("\n                Xác nhận\n                "),
                  _c("v-icon", { attrs: { right: "" } }, [
                    _vm._v(" mdi-check "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/tool/qrcode/qrcode.create.vue